import "./style.scss";
import { Typography } from "components";

const ButtonSwitch = ({
  leftLabel = "Active",
  rightLabel = "Inactive",
  handleClick,
  value = 0,
}) => {
  return (
    <div className="btn-switch row" onClick={handleClick}>
      <div className={`col-6 ${value === 0 ? "active-btn" : "inactive-btn"}`}>
        <Typography>{leftLabel}</Typography>
      </div>
      <div className={`col-6 ${value === 1 ? "active-btn" : "inactive-btn"}`}>
        <Typography>{rightLabel}</Typography>
      </div>
    </div>
  );
};

export default ButtonSwitch;
